import { useMemo } from 'react';

// SpecRef: ARCH-002 (PNG primary transport)
// Reference: docs/decisions/ARCH-002-webgl-heatmap-migration.md#griddata-type-change
import {
  useQueryWindsForecastGridPng,
  type WindsForecastGridSearchParams,
} from '../../../api';

import type { Grid } from '../types';

export type GridStatus = 'pending' | 'processing' | 'success' | 'error';
// Maximum number of cache entries to keep
export const useGrid = (
  params: WindsForecastGridSearchParams,
): Omit<Grid, 'params'> & {
  status: GridStatus;
  maxWindSpeed: number;
} => {
  const { data: pngData, status } = useQueryWindsForecastGridPng({
    dref: params.dref,
    level: params.level,
    fhr: params.fhr,
    tref: params.tref,
  });

  const { data, height, width, maxWindSpeed } = useMemo(() => {
    if (!pngData) {
      return { data: null, height: 0, width: 0, maxWindSpeed: 30 };
    }
    return {
      data: pngData.blob,
      height: pngData.height,
      width: pngData.width,
      maxWindSpeed: pngData.maxWindSpeed,
    };
  }, [pngData]);
  return { status, data, height, width, maxWindSpeed };
};
